<template>
    <div class="main-container">
        <div class="topBar">
            <div class="DropDownBox">
 
                <label class="empStatus">Employee status</label>
                <tl-select class="empstatusDropdown" :options="EnployeeStatus" @change="(val) => rpttypechanged(val)" />
                <div>
                    <search-dropdown class='searchDRopDown' placeholder="Search Employee" 
                        :clearRequired="true"  />
                </div>
                <div>
                    <button type="button" class="btn btn-secondary button">Search</button>
                </div>
            </div>

            <div>
                <button type="button" v-on:click="fetchAllUnClaimedData" class="btn btn-primary button">Process Un-Claimed FBP</button>
            </div>
        </div>
        <div class="tableList">
            <data-table class="tableClass" :columns="fbpColums" :tableData="fbpData" :showinrow="true" @editStart="false"
                :showedit="false" :showdelete="false" :showhistory="false">
                <template v-slot:rowcontent="slotprops">
                    <p v-if="slotprops.value.column.key == 'employee_code'">
                        {{ slotprops.value.record.employee_code ? slotprops.value.record.employee_code: "" }}
                    </p>
                    <p v-if="slotprops.value.column.key == 'employee_name'">
                        {{ slotprops.value.record.employee_name }}
                    </p>

                    <p v-if="slotprops.value.column.key == 'totalEligibleAmount'">
                        {{ slotprops.value.record.totalEligibleAmount}}
                    </p>
                    <p v-if="slotprops.value.column.key == 'totalClaimedAmount'">
                        {{ slotprops.value.record.totalClaimedAmount }}
                    </p>
                    <p v-if="slotprops.value.column.key == 'totalUnClaimedAmount'">
                        {{ slotprops.value.record.totalUnClaimedAmount}}
                    </p>
                </template>
            </data-table>
        </div>
        <footer>
          <bottom-action-container>
            <template slot="end">
              <btn-grp>
                <btn
                  text="Dashboard"
                  type="secondary"
                  v-on:click="goBack"
                ></btn>
              </btn-grp>
            </template>
            <div class="text-center">
    <v-container>
      <v-row justify="center">
        <v-col cols="8">
          <v-container class="max-width">
            <v-pagination
              v-model="page"
              @input="updatePage"
              class="my-4"
              :length="5"
            ></v-pagination>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </div>
          </bottom-action-container>
        </footer>
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
export default {
 
    data() {
        return {
            page:1,
            EnployeeStatus: ["Active", "Resigned"],
            fbpColums: [
                {
                    label: "E-Code",
                    key: "employee_code",
                },
                {
                    label: "Name",
                    key: "employee_name",
                },
                {
                    label: "Eligible (Rs)",
                    key: "totalEligibleAmount",
                },
                {
                    label: "Claimed (Rs)",
                    key: "totalClaimedAmount",
                },
                {
                    label: "Unclaimed (Rs)",
                    key: "totalUnClaimedAmount",
                },
            ],
            fbpData: [],
            
        }
    },
    mounted(){
      
    },
    computed:{
        ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
        le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    
      financial_year(){
        console.log("i am called",localStorage.getItem("financialYear"))
        return localStorage.getItem("financialYear")
      }
    },
    methods:{
        ...mapActions({
         act_fetchAll : "dashboard/humanResource/fbpUnclaim/fetchAll"
        }),
        goBack(){
            this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/fbpPayroll`,
      });
        },
        updatePage: function(pageIndex) {
            console.log("called",pageIndex)
        },
        async fetchAllUnClaimedData(){
          try{
            console.log("i am called",this.le_id,this.financial_year)
             let res= await this.act_fetchAll({
                le_id : this.le_id,
                financial_year: this.financial_year
             })
             this.fbpData = res.data.payload.unClaimedData
             console.log(this.unClaimedData)
          }catch(err){

          }
        }
    },
   
}
</script>
<style scoped>
.topBar {
    display: flex;
    justify-content: space-between;
}

.DropDownBox {
    display: flex;
    gap: 35px;
}

.empStatus {
    align-self: center;
    color: rgba(125, 130, 130, 0.988);
    font-size: 16px;
    font-style: inherit;
    font-weight: 500;
}

.empstatusDropdown{
    width: 200px;
}

.searchDRopDown {
    margin-top: -9px;
}

.button {
    background-color: rgb(70, 70, 160);
    color: white;
}

</style>